import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// One static import per namespace per language. ~120 small imports — webpack
// inlines them as separate chunks but they all load at startup like before.

import en_accept_invite from "./locales/en/accept_invite.json";
import el_accept_invite from "./locales/el/accept_invite.json";
import en_admin from "./locales/en/admin.json";
import el_admin from "./locales/el/admin.json";
import en_admin_analytics from "./locales/en/admin_analytics.json";
import el_admin_analytics from "./locales/el/admin_analytics.json";
import en_admin_billing from "./locales/en/admin_billing.json";
import el_admin_billing from "./locales/el/admin_billing.json";
import en_admin_bookings from "./locales/en/admin_bookings.json";
import el_admin_bookings from "./locales/el/admin_bookings.json";
import en_admin_branding from "./locales/en/admin_branding.json";
import el_admin_branding from "./locales/el/admin_branding.json";
import en_admin_cms from "./locales/en/admin_cms.json";
import el_admin_cms from "./locales/el/admin_cms.json";
import en_admin_collections from "./locales/en/admin_collections.json";
import el_admin_collections from "./locales/el/admin_collections.json";
import en_admin_csv from "./locales/en/admin_csv.json";
import el_admin_csv from "./locales/el/admin_csv.json";
import en_admin_reviews from "./locales/en/admin_reviews.json";
import el_admin_reviews from "./locales/el/admin_reviews.json";
import en_reviews from "./locales/en/reviews.json";
import el_reviews from "./locales/el/reviews.json";
import en_admin_dashboard from "./locales/en/admin_dashboard.json";
import el_admin_dashboard from "./locales/el/admin_dashboard.json";
import en_admin_data_tools from "./locales/en/admin_data_tools.json";
import el_admin_data_tools from "./locales/el/admin_data_tools.json";
import en_admin_footer from "./locales/en/admin_footer.json";
import el_admin_footer from "./locales/el/admin_footer.json";
import en_admin_invitations from "./locales/en/admin_invitations.json";
import el_admin_invitations from "./locales/el/admin_invitations.json";
import en_admin_layouts from "./locales/en/admin_layouts.json";
import el_admin_layouts from "./locales/el/admin_layouts.json";
import en_admin_logins from "./locales/en/admin_logins.json";
import el_admin_logins from "./locales/el/admin_logins.json";
import en_admin_maintenance from "./locales/en/admin_maintenance.json";
import el_admin_maintenance from "./locales/el/admin_maintenance.json";
import en_admin_messages from "./locales/en/admin_messages.json";
import el_admin_messages from "./locales/el/admin_messages.json";
import en_admin_tag_groups from "./locales/en/admin_tag_groups.json";
import el_admin_tag_groups from "./locales/el/admin_tag_groups.json";
import en_admin_taxonomy from "./locales/en/admin_taxonomy.json";
import el_admin_taxonomy from "./locales/el/admin_taxonomy.json";
import en_admin_users from "./locales/en/admin_users.json";
import el_admin_users from "./locales/el/admin_users.json";
import en_admin_venue_claims from "./locales/en/admin_venue_claims.json";
import el_admin_venue_claims from "./locales/el/admin_venue_claims.json";
import en_admin_venue_edit from "./locales/en/admin_venue_edit.json";
import el_admin_venue_edit from "./locales/el/admin_venue_edit.json";
import en_admin_venue_plans from "./locales/en/admin_venue_plans.json";
import el_admin_venue_plans from "./locales/el/admin_venue_plans.json";
import en_admin_venues from "./locales/en/admin_venues.json";
import el_admin_venues from "./locales/el/admin_venues.json";
import en_auth from "./locales/en/auth.json";
import el_auth from "./locales/el/auth.json";
import en_billing from "./locales/en/billing.json";
import el_billing from "./locales/el/billing.json";
import en_booking from "./locales/en/booking.json";
import el_booking from "./locales/el/booking.json";
import en_booking_status from "./locales/en/booking_status.json";
import el_booking_status from "./locales/el/booking_status.json";
import en_collections_page from "./locales/en/collections_page.json";
import el_collections_page from "./locales/el/collections_page.json";
import en_common from "./locales/en/common.json";
import el_common from "./locales/el/common.json";
import en_customer from "./locales/en/customer.json";
import el_customer from "./locales/el/customer.json";
import en_customer_dashboard from "./locales/en/customer_dashboard.json";
import el_customer_dashboard from "./locales/el/customer_dashboard.json";
import en_customer_loyalty from "./locales/en/customer_loyalty.json";
import el_customer_loyalty from "./locales/el/customer_loyalty.json";
import en_date_filter from "./locales/en/date_filter.json";
import el_date_filter from "./locales/el/date_filter.json";
import en_dietary_tags from "./locales/en/dietary_tags.json";
import el_dietary_tags from "./locales/el/dietary_tags.json";
import en_events_page from "./locales/en/events_page.json";
import el_events_page from "./locales/el/events_page.json";
import en_footer from "./locales/en/footer.json";
import el_footer from "./locales/el/footer.json";
import en_forgot from "./locales/en/forgot.json";
import el_forgot from "./locales/el/forgot.json";
import en_gallery from "./locales/en/gallery.json";
import el_gallery from "./locales/el/gallery.json";
import en_home from "./locales/en/home.json";
import el_home from "./locales/el/home.json";
import en_login from "./locales/en/login.json";
import el_login from "./locales/el/login.json";
import en_loyalty from "./locales/en/loyalty.json";
import el_loyalty from "./locales/el/loyalty.json";
import en_maintenance from "./locales/en/maintenance.json";
import el_maintenance from "./locales/el/maintenance.json";
import en_map_page from "./locales/en/map_page.json";
import el_map_page from "./locales/el/map_page.json";
import en_nav from "./locales/en/nav.json";
import el_nav from "./locales/el/nav.json";
import en_notifications from "./locales/en/notifications.json";
import el_notifications from "./locales/el/notifications.json";
import en_owner from "./locales/en/owner.json";
import el_owner from "./locales/el/owner.json";
import en_owner_availability from "./locales/en/owner_availability.json";
import el_owner_availability from "./locales/el/owner_availability.json";
import en_owner_calendar from "./locales/en/owner_calendar.json";
import el_owner_calendar from "./locales/el/owner_calendar.json";
import en_owner_gallery from "./locales/en/owner_gallery.json";
import el_owner_gallery from "./locales/el/owner_gallery.json";
import en_owner_menu from "./locales/en/owner_menu.json";
import el_owner_menu from "./locales/el/owner_menu.json";
import en_owner_preview from "./locales/en/owner_preview.json";
import el_owner_preview from "./locales/el/owner_preview.json";
import en_owner_promotions from "./locales/en/owner_promotions.json";
import el_owner_promotions from "./locales/el/owner_promotions.json";
import en_owner_scheduling from "./locales/en/owner_scheduling.json";
import el_owner_scheduling from "./locales/el/owner_scheduling.json";
import en_owner_scorecard from "./locales/en/owner_scorecard.json";
import el_owner_scorecard from "./locales/el/owner_scorecard.json";
import en_owner_venue from "./locales/en/owner_venue.json";
import el_owner_venue from "./locales/el/owner_venue.json";
import en_pricing from "./locales/en/pricing.json";
import el_pricing from "./locales/el/pricing.json";
import en_reset from "./locales/en/reset.json";
import el_reset from "./locales/el/reset.json";
import en_scorecard from "./locales/en/scorecard.json";
import el_scorecard from "./locales/el/scorecard.json";
import en_signup from "./locales/en/signup.json";
import el_signup from "./locales/el/signup.json";
import en_subscription_status from "./locales/en/subscription_status.json";
import el_subscription_status from "./locales/el/subscription_status.json";
import en_venue from "./locales/en/venue.json";
import el_venue from "./locales/el/venue.json";
import en_venues_page from "./locales/en/venues_page.json";
import el_venues_page from "./locales/el/venues_page.json";

const enResources = {
  accept_invite: en_accept_invite,
  admin: en_admin,
  admin_analytics: en_admin_analytics,
  admin_billing: en_admin_billing,
  admin_bookings: en_admin_bookings,
  admin_branding: en_admin_branding,
  admin_cms: en_admin_cms,
  admin_collections: en_admin_collections,
  admin_csv: en_admin_csv,
  admin_reviews: en_admin_reviews,
  reviews: en_reviews,
  admin_dashboard: en_admin_dashboard,
  admin_data_tools: en_admin_data_tools,
  admin_footer: en_admin_footer,
  admin_invitations: en_admin_invitations,
  admin_layouts: en_admin_layouts,
  admin_logins: en_admin_logins,
  admin_maintenance: en_admin_maintenance,
  admin_messages: en_admin_messages,
  admin_tag_groups: en_admin_tag_groups,
  admin_taxonomy: en_admin_taxonomy,
  admin_users: en_admin_users,
  admin_venue_claims: en_admin_venue_claims,
  admin_venue_edit: en_admin_venue_edit,
  admin_venue_plans: en_admin_venue_plans,
  admin_venues: en_admin_venues,
  auth: en_auth,
  billing: en_billing,
  booking: en_booking,
  booking_status: en_booking_status,
  collections_page: en_collections_page,
  common: en_common,
  customer: en_customer,
  customer_dashboard: en_customer_dashboard,
  customer_loyalty: en_customer_loyalty,
  date_filter: en_date_filter,
  dietary_tags: en_dietary_tags,
  events_page: en_events_page,
  footer: en_footer,
  forgot: en_forgot,
  gallery: en_gallery,
  home: en_home,
  login: en_login,
  loyalty: en_loyalty,
  maintenance: en_maintenance,
  map_page: en_map_page,
  nav: en_nav,
  notifications: en_notifications,
  owner: en_owner,
  owner_availability: en_owner_availability,
  owner_calendar: en_owner_calendar,
  owner_gallery: en_owner_gallery,
  owner_menu: en_owner_menu,
  owner_preview: en_owner_preview,
  owner_promotions: en_owner_promotions,
  owner_scheduling: en_owner_scheduling,
  owner_scorecard: en_owner_scorecard,
  owner_venue: en_owner_venue,
  pricing: en_pricing,
  reset: en_reset,
  scorecard: en_scorecard,
  signup: en_signup,
  subscription_status: en_subscription_status,
  venue: en_venue,
  venues_page: en_venues_page,
};
const elResources = {
  accept_invite: el_accept_invite,
  admin: el_admin,
  admin_analytics: el_admin_analytics,
  admin_billing: el_admin_billing,
  admin_bookings: el_admin_bookings,
  admin_branding: el_admin_branding,
  admin_cms: el_admin_cms,
  admin_collections: el_admin_collections,
  admin_csv: el_admin_csv,
  admin_reviews: el_admin_reviews,
  reviews: el_reviews,
  admin_dashboard: el_admin_dashboard,
  admin_data_tools: el_admin_data_tools,
  admin_footer: el_admin_footer,
  admin_invitations: el_admin_invitations,
  admin_layouts: el_admin_layouts,
  admin_logins: el_admin_logins,
  admin_maintenance: el_admin_maintenance,
  admin_messages: el_admin_messages,
  admin_tag_groups: el_admin_tag_groups,
  admin_taxonomy: el_admin_taxonomy,
  admin_users: el_admin_users,
  admin_venue_claims: el_admin_venue_claims,
  admin_venue_edit: el_admin_venue_edit,
  admin_venue_plans: el_admin_venue_plans,
  admin_venues: el_admin_venues,
  auth: el_auth,
  billing: el_billing,
  booking: el_booking,
  booking_status: el_booking_status,
  collections_page: el_collections_page,
  common: el_common,
  customer: el_customer,
  customer_dashboard: el_customer_dashboard,
  customer_loyalty: el_customer_loyalty,
  date_filter: el_date_filter,
  dietary_tags: el_dietary_tags,
  events_page: el_events_page,
  footer: el_footer,
  forgot: el_forgot,
  gallery: el_gallery,
  home: el_home,
  login: el_login,
  loyalty: el_loyalty,
  maintenance: el_maintenance,
  map_page: el_map_page,
  nav: el_nav,
  notifications: el_notifications,
  owner: el_owner,
  owner_availability: el_owner_availability,
  owner_calendar: el_owner_calendar,
  owner_gallery: el_owner_gallery,
  owner_menu: el_owner_menu,
  owner_preview: el_owner_preview,
  owner_promotions: el_owner_promotions,
  owner_scheduling: el_owner_scheduling,
  owner_scorecard: el_owner_scorecard,
  owner_venue: el_owner_venue,
  pricing: el_pricing,
  reset: el_reset,
  scorecard: el_scorecard,
  signup: el_signup,
  subscription_status: el_subscription_status,
  venue: el_venue,
  venues_page: el_venues_page,
};

const savedLang =
  typeof window !== "undefined"
    ? localStorage.getItem("tavlacy_lang") || "en"
    : "en";

const allNamespaces = Object.keys(enResources);

i18n.use(initReactI18next).init({
  resources: { en: enResources, el: elResources },
  lng: savedLang,
  fallbackLng: "en",
  supportedLngs: ["en", "el"],
  ns: allNamespaces,
  defaultNS: "common",
  fallbackNS: "common",
  // t("venue:title") → namespace "venue", key "title".
  // Nested keys inside a namespace still use dot, e.g. t("venue:section.sub").
  nsSeparator: ":",
  keySeparator: ".",
  interpolation: { escapeValue: false },
  // The whole resource bundle is statically imported, so disable Suspense
  // — there's nothing to wait for and the default (true) blanks the page
  // until every namespace acks "loaded".
  react: { useSuspense: false },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("tavlacy_lang", lng);
});

export default i18n;
